import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { IconButton, Stack } from '@mui/material'
import { ICellRendererParams } from 'ag-grid-community'
import { PLACEHOLDER } from 'components/column-renderers'
import copy from 'copy-to-clipboard'
import { EAccessCodeStatus } from 'types'

export const AccessManagementColumnCode = (
  props: ICellRendererParams<{ [code: string]: string }>,
) => {
  const isDraft = props?.data?.status === EAccessCodeStatus.draft
  const code = props?.data?.code
  if (!code || isDraft) {
    return PLACEHOLDER
  }

  const copyToClipboard = () => {
    copy(code, {
      format: 'text/plain',
    })
  }

  return (
    <Stack direction="row" spacing={1} alignItems="center" style={{ height: '100%' }}>
      <span style={{ whiteSpace: 'nowrap', flexShrink: 0 }}>{code}</span>
      <IconButton component="label" onClick={copyToClipboard} size="small" sx={{ padding: '8px' }}>
        <ContentCopyIcon style={{ width: 24, height: 24 }} />
      </IconButton>
    </Stack>
  )
}
